// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverSparql, _, cuid, util,
    indexOf = [].indexOf;

  _ = require('lodash');

  cuid = require('cuid');

  util = require('./util');

  Weaver = require('./Weaver');

  WeaverSparql = class WeaverSparql {
    constructor(_query, target, branchId) {
      this._query = _query;
      this.target = target;
      this.branchId = branchId;
      this._limit = 99999;
      this._skip = 0;
      this._nextResults = false;
      this._keepOpen = false;
      this._resultSetId = void 0;
      this._autoClose = true;
      this._parameters = {};
    }

    withParameters(_parameters) {
      this._parameters = _parameters;
      return this;
    }

    findNodesQuery(query) {
      this._findNodesQuery = query;
      return this;
    }

    next() {
      this._nextResults = true;
      return this.find();
    }

    async _getTransaction() {
      var cm, ref;
      if ((this.transaction == null) && !this._keepOpen) {
        return;
      }
      cm = Weaver.getCoreManager();
      if (this.transaction == null) {
        if (this._keepOpen) {
          this._autoClose = true;
        }
        return this.transaction = (await Weaver.getInstance().startTransaction({
          branch: this.branchId || ((ref = cm.currentBranch) != null ? ref.id() : void 0) || cm.defaultBranch,
          project: this.target
        }));
      } else {
        return this.transaction;
      }
    }

    useTransaction(transaction) {
      this.transaction = transaction;
      this._autoClose = false;
      return this;
    }

    findNodes() {
      return this.find(true);
    }

    async find(findNodes = false) {
      var binding, clone, columns, i, index, j, len, len1, name, nr, object, record, ref, ref1, result, resultMap, row;
      this._query = Weaver.QueryBuilder.substituteParameters(this._query, this._parameters);
      resultMap = {};
      await this._getTransaction(); // will only start transaction if needed
      clone = this.preSerialize();
      if (this.transaction != null) {
        clone._transaction = this.transaction.id();
        clone.target = this.transaction.getProject();
      }
      result = (await Weaver.getCoreManager().sparql(clone));
      columns = {};
      ref = result.columnNames;
      for (name in ref) {
        nr = ref[name];
        columns[nr] = name;
        if (resultMap[name] == null) {
          resultMap[name] = new Weaver.NodeList();
        }
      }
      this.ids = result.ids;
      ref1 = result.rows;
      for (i = 0, len = ref1.length; i < len; i++) {
        row = ref1[i];
        for (index = j = 0, len1 = row.length; j < len1; index = ++j) {
          object = row[index];
          binding = columns[index];
          if ((object != null ? object.value : void 0) != null) {
            if (object.dataType == null) {
              object.dataType = util.guessDataType(object.value);
            }
            object.value = Weaver.Attribute.parseValue(object.value, object.dataType);
            record = new Weaver.Attribute.Record(void 0, object.value, object.dataType, void 0);
            resultMap[binding].push(record);
          } else if (object != null) {
            resultMap[binding].push(Weaver.Node.loadFromQuery(object));
          } else {
            resultMap[binding].push(null);
          }
        }
      }
      if ((this.transaction != null) && this._autoClose && !this._keepOpen) {
        await this.transaction.commit();
        this.transaction = void 0;
      }
      if (findNodes) {
        if (this._findNodesQuery == null) {
          this._findNodesQuery = new Weaver.Query();
        }
        return this._findNodesQuery.restrict(this.ids).unlimited();
      } else {
        return resultMap;
      }
    }

    async close() {
      if (this.transaction == null) {
        return;
      }
      if (this._keepOpen) {
        await Weaver.getCoreManager().releaseResultSet(this.transaction, this._resultSetId);
      }
      if (this._autoClose) {
        await this.transaction.commit();
        return this.transaction = void 0;
      }
    }

    skip(skip) {
      if (typeof skip !== 'number' || skip < 0) {
        throw new Error('Invalid argument: skip should be a positive number');
      }
      this._skip = skip;
      return this;
    }

    limit(limit) {
      if (typeof limit !== 'number' || limit < 0) {
        throw new Error('Invalid argument: limit should be a positive number');
      }
      this._limit = limit;
      return this;
    }

    batchSize(batchSize) {
      this._batchSize = batchSize;
      return this;
    }

    keepOpen(keepOpen = true) {
      this._keepOpen = keepOpen;
      if (keepOpen) {
        if (this._resultSetId == null) {
          this._resultSetId = cuid();
        }
      } else {
        this._resultSetId = void 0;
      }
      return this;
    }

    useCache(set = true) {
      this._useCache = set;
      return this;
    }

    refreshCache(set = true) {
      this._refreshCache = set;
      return this;
    }

    preSerialize() {
      return _.omit(this, []);
    }

    iterator(hierarchyMap = {}, top, nodeMapping = (function(n) {
        return n;
      }), attributeMapping = (function(a) {
        return a;
      })) {
      return {
        hierarchyMap,
        top,
        query: this.keepOpen(),
        currentRes: void 0,
        currentObject: void 0,
        currentRow: void 0,
        nextRow: void 0,
        rowPointer: 0,
        res: {
          children: []
        },
        exhausted: false,
        index: function(obj) {
          if (obj instanceof Weaver.Attribute.Record) {
            return obj.value;
          } else if (obj instanceof Weaver.Node) {
            return obj.id();
          } else {
            return obj;
          }
        },
        isSame: function(left, right) {
          return this.index(left) === this.index(right);
        },
        nonExhaustedRes: async function() {
          var column, key, ref, ref1;
          if (this.currentRes == null) {
            this.currentRes = (await this.query.find());
          }
          ref = this.currentRes;
          for (key in ref) {
            column = ref[key];
            if (this.rowPointer === this.currentRes[key].length) {
              await (this.currentRes = (await this.query.next()));
              this.rowPointer = 0;
            }
            break;
          }
          ref1 = this.currentRes;
          for (key in ref1) {
            column = ref1[key];
            if (this.currentRes[key].length === 0) {
              await this.query.close();
              return void 0;
            }
            break;
          }
          return this.currentRes;
        },
        lookAheadRow: async function() {
          var column, item, key, ref, res, row;
          res = (await this.nonExhaustedRes());
          if (res == null) {
            this.exhausted = true;
            return void 0;
          }
          row = {};
          ref = this.currentRes;
          for (key in ref) {
            column = ref[key];
            item = column[this.rowPointer];
            if (item instanceof Weaver.Attribute.Record) {
              row[key] = attributeMapping(item);
            } else {
              row[key] = nodeMapping(item);
            }
          }
          this.rowPointer++;
          return row;
        },
        addToObject: function(res, row, hier, done = [], path = []) {
          var addValue, base, breadcrumb, i, key, len, parent, parentKey, ref, rest, value;
          addValue = (list, value) => {
            var i, item, len;
            for (i = 0, len = list.length; i < len; i++) {
              item = list[i];
              if (this.isSame(item.value, value)) {
                return;
              }
            }
            return list.push({
              value,
              children: {}
            });
          };
// should be attached to current object
          for (key in row) {
            value = row[key];
            if (indexOf.call(done, key) >= 0) {
              continue;
            }
            if (hier[key] == null) {
              // attach to current object's children
              if ((base = res.children)[key] == null) {
                base[key] = [];
              }
              addValue(res.children[key], value);
              done.push(key);
            }
          }
// should go somewhere deep
          for (key in row) {
            value = row[key];
            if (indexOf.call(done, key) >= 0) {
              continue;
            }
            if ((hier[key] != null) && (hier[hier[key]] == null) && (path.length === 0 || hier[key] === path.slice(-1)[0])) {
              parentKey = hier[key];
              ref = res.children[parentKey];
              for (i = 0, len = ref.length; i < len; i++) {
                parent = ref[i];
                if (this.isSame(parent.value, row[parentKey])) {
                  rest = Object.assign({}, hier);
                  delete rest[key];
                  breadcrumb = [...path];
                  breadcrumb.push(key);
                  this.addToObject(parent, row, rest, done, breadcrumb);
                }
              }
            }
          }
          return void 0;
        },
        next: async function() {
          var ref;
          if (this.exhausted) {
            return {
              done: true
            };
          }
          this.res.children = {};
          if (this.nextRow == null) {
            this.nextRow = (await this.lookAheadRow());
          }
          if (this.exhausted) {
            return {
              done: true
            };
          }
          while (!this.exhausted) {
            this.currentRow = this.nextRow;
            this.addToObject(this.res, this.currentRow, this.hierarchyMap);
            this.nextRow = (await this.lookAheadRow());
            if ((this.top == null) || !this.isSame(this.currentRow[this.top], (ref = this.nextRow) != null ? ref[this.top] : void 0)) {
              break;
            }
          }
          return {
            done: false,
            value: this.res.children
          };
        },
        all: function() {
          return new Promise(async(resolve) => {
            var results, row, rows;
            rows = [];
            results = [];
            while (true) {
              row = (await this.next());
              if (row.done) {
                resolve(rows);
                break;
              } else {
                results.push(rows.push(row.value));
              }
            }
            return results;
          });
        }
      };
    }

  };

  // Export
  module.exports = WeaverSparql;

}).call(this);
